/*
*###############################################################################
*Module Name                   : VoucherTransferOutController.js               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Tuesday, January 4th 2022, 1:01:02 pm         #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

const getLocationDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherGroup = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGroup/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



const getVoucherBook = async (Category, Location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }

  await fetch(`${ApiURL}VoucherTRO/GetBookList/${Category}/${Location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherNumber = async (Category, Location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }

  await fetch(`${ApiURL}VoucherTRO/GetVoucherNumberList/${Category}/${Location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
// Voucher Group save method
const setVoucherSave = async (
  strVoucherCode,
  strVoucherDate,
  LocationCode,
  LogCompanyCode,
  strFromLocation,
  strToLocation,
  strRemarks1,
  strRemarks2,
  strRefNo,
  LogUserType,
  menuCode,
  LogCompanyCodenew,
  LocationCodenew,
  strReason,
  VoucherPoDet

) => {
  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Authorization", `Bearer ${authToken}`)
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strType: 'VTO',
    strRunNo: strVoucherCode,
    dtTxnDate: strVoucherDate,
    dtTxnTime: strVoucherDate,
    strSetupLoc: LocationCode,
    strComCode: LogCompanyCode,
    strFromLocCode: strFromLocation,
    strToLocCode: strToLocation,
    strRef1: strRemarks1,
    strRef2: strRemarks2,
    strRefNo: strRefNo,
    strBatchNo: '',
    intHedProcess: 1,
    intHedCancelled: 0,
    dtCancellDate: '1900-01-01',
    strCancelldUser: '',
    dbPrintCount: 0,
    intHedFullyUsed: 1,
    intExport: 0,
    strExportBatch: '',
    strCreateBy: LogUserType,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
    strReason: LogCompanyCode,
    VCTRODETAILS: VoucherPoDet

  })

  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}VoucherTRO`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}


const getVoucherPOSearch = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/PendingPo`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherPOHeader = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/search/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherPendingPOHeader = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/searchPending/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherTROSearch = async strFromLocation => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRO/${strFromLocation}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherTROHeader = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var success = false
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRO/search/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
      success = result.success
    })
    .catch(error => console.log("error", error))
  return { data, success }
}


const getminVoucherNumber = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }

  await fetch(`${ApiURL}VoucherTRO/GetBookListPrint/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



const getmaxVoucherNumber = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }

  await fetch(`${ApiURL}VoucherTRO/GetBookListPrint/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherREQHeader = async (voucherCode, location) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");
    var data = [];
    var requestOptions = {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: "follow",
    };

    const response = await fetch(`${ApiURL}voucherRequest/TROSearch/${voucherCode}/${location}`, requestOptions);
    const result = await response.json();

    if (result.data.length > 0) {
      return { success: true, data: result.data[0] };
    }
    // Return both success and data
    return { success: false, data: {} };
  } catch (error) {
    console.error("Error:", error);
    // Return both success (false in this case) and an error message
    return { success: false, data: data, error: error.message };
  }
};


const CancelVoucher = async (jsonBody) => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");
  let isSuccessful = false;
  let message = "";

  const requestOptions = {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${authToken}`,
      "Content-Type": "application/json", // Ensure you set the content type
    },
    body: JSON.stringify(jsonBody),
    redirect: "follow",
  };

  try {
    const response = await fetch(`${ApiURL}VoucherTRO/Cancel`, requestOptions);
    const result = await response.json();

    if (result.success) {
      isSuccessful = true;
      message = result.data;
    } else {
      message = result.data;
    }

  } catch (error) {
    console.error("Error occurred:", error); // Use console.error for errors
  }

  return { isSuccessful, message };
};



export {
  getLocationDets,
  getVoucherGroup,
  setVoucherSave,
  getVoucherPOSearch,
  getVoucherPOHeader,
  getVoucherTROSearch,
  getVoucherTROHeader,
  getVoucherPendingPOHeader,
  getVoucherBook,
  getVoucherNumber,
  getminVoucherNumber,
  getmaxVoucherNumber,
  getVoucherREQHeader,
  CancelVoucher
}